var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Focus"},[_c('custList',{attrs:{"sysBoxValue":_vm.sysBoxValue}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }